import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { restoreSessionFromOtherTabs } from '@core/auth';

// Share the session with already-open tabs before bootstrapping so a tab opened
// from a link doesn't start with an empty sessionStorage and re-trigger Auth0.
restoreSessionFromOtherTabs()
  .then(() => bootstrapApplication(App, appConfig))
  .catch((err) => console.error(err));
